// IMPORT
import React, { useEffect, useState } from 'react';
import { isArray, isNil, map, isEmpty } from 'lodash';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// COMPONENT
import VoucherListPlatformComponent from 'Components/voucher-list/platform';
import VoucherListSellerComponent from 'Components/voucher-list/seller';

// ANT COMPONENT
import { Col, Row } from 'antd';
import { ApartmentOutlined } from '@ant-design/icons';

// STYLE
import './voucher-deals.scss'

// SERVICE
import { getVoucherList } from 'Services/voucher.service';

interface VoucherDealsPageProps { }

const VoucherDealsPage: React.FC<VoucherDealsPageProps> = () => {

    const { t } = useTranslation();

    const { id } = useParams<{ id: string }>();

    // DEFINE STATE
    const [voucherType, setVoucherType] = useState<Number>(id ? parseFloat(id) > 4 ? 1 : parseFloat(id) : 1);
    const [voucherListPlatform, setVoucherListPlatform] = useState<any>([]);
    const [voucherListSeller, setVoucherListSeller] = useState<any>([]);

    // VOUCHER LIST FUNCTION
    const voucherListFunc = async (keys: string[], values: string[]) => {
        // REQUIRED FILTER
        const platformFilter = {filters : {
            voucherBy: "PLATFORM",
            sourceSite: process.env.ACCOUNT_TYPE,
        }};
        const sellerFilter = {filters : {
            voucherBy: "SELLER",
            sourceSite: process.env.ACCOUNT_TYPE,
        }};

        // LOOP AND ADD CONDITIONAL FILTER
        keys.map((key, index) => {
            sellerFilter.filters[key] = values[index];
            platformFilter.filters[key] = values[index];
        });

        // GET VOUCHER LIST API
        const responsePlatformData = await getVoucherList(platformFilter);
        const responseSellerData = await getVoucherList(sellerFilter);

        // OUTPUT === ARRAY => VALID RESPONSE, SET VALUES
        if (isArray(responsePlatformData)) {
            setVoucherListPlatform(responsePlatformData);
        }
        if (isArray(responseSellerData)) {
            setVoucherListSeller(responseSellerData);
        }
    }

    // VOUCHER LIST TYPE CHANGED AND CALL API FOR NEW LIST
    const voucherTypeChanged = () => {
        switch (voucherType) {
            case 1: {
                voucherListFunc(["voucherType"], ["PRODUCT"]);
                break;
            }
            case 2: {
                voucherListFunc(["voucherType"], ["SHIPPING"]);
                break;
            }
            case 3: {
                voucherListFunc(["discountValue", "discountType"], ["50", "PERCENTAGE"]);
                break;
            }
            case 4: {
                voucherListFunc(["minAmount"], ["0"]);
                break;
            }
            default: {
                voucherListFunc(["voucherType"], ["PRODUCT"]);
                break;
            }
        }
    }

    useEffect(() => {
        voucherTypeChanged();
    }, [voucherType])

    return (
        <div>
            <div className="header-title py-25">{t('label.BestVoucherDeals')}</div>
            <div className="discount-type">
                <Row className="container" gutter={10}>
                    <Col className="py-30" span={6}>
                        <span onClick={() => setVoucherType(1)} 
                        className={voucherType === 1 ? "selected" : "types-tab"}>
                            <img src="/assets/images/product-discount.svg" className="mr-5"/>
                            {t('tab.ProductDiscounts')}
                        </span>
                    </Col>
                    <Col className="py-30" span={6}>
                        <span onClick={() => setVoucherType(2)} 
                        className={voucherType === 2 ? "selected" : "types-tab"}>
                            <img src="/assets/images/shipping-discount.svg" className="mr-5"/>
                            {t('tab.ShippingDiscounts')}
                        </span>
                    </Col>
                    <Col className="py-30" span={6}>
                        <span onClick={() => setVoucherType(3)} 
                        className={voucherType === 3 ? "selected" : "types-tab"}>
                            <img src="/assets/images/half-price.svg" className="mr-5"/>
                            {t('tab.LessThanHalfPrice')}
                        </span>
                    </Col>
                    <Col className="py-30" span={6}>
                        <span onClick={() => setVoucherType(4)} 
                        className={voucherType === 4 ? "selected" : "types-tab"}>
                            <img src="/assets/images/zero-min-spend.svg" className="mr-5"/>
                            {t('tab.NoMinSpend')}
                        </span>
                    </Col>
                </Row>
            </div>
            <div className="container mt-20">
                {
                    isArray(voucherListPlatform) && !isEmpty(voucherListPlatform) ?
                        <VoucherListPlatformComponent bannerVoucherList={voucherListPlatform}></VoucherListPlatformComponent>
                        : null
                }
                {
                    isArray(voucherListSeller) && !isEmpty(voucherListSeller) ?
                        <div className="mt-20">
                            <VoucherListSellerComponent hideTitle={true} voucherList={voucherListSeller}></VoucherListSellerComponent>
                        </div>
                        : null
                }
                {
                    isArray(voucherListSeller) && isEmpty(voucherListSeller)
                    && isArray(voucherListPlatform) && isEmpty(voucherListPlatform) ?
                        <div>
                            <img className="empty-voucher-list mt-50" src="/assets/images/empty-voucher.svg"></img>
                            <div className="mt-25 empty-main-label">{t('label.EmptyDeals')}</div>
                            <div className="mt-10 empty-secondary-label">{t('label.CheckAgainForDeals')}</div>
                        </div>
                        : null
                }
            </div>
        </div>
    )
}

export default VoucherDealsPage;

